<div class="invoice-card-list">
  <app-invoice-card
    *ngFor="let card of cards; trackBy: trackCard"
    [card]="card"
    (actionSelected)="onAction(card, $event)">
  </app-invoice-card>
</div>

